import React, { useContext, useEffect, useState } from "react";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty, startCase } from "lodash";
import { Link, NavLink } from "react-router-dom";
import dayjs from "dayjs";

const ProjectTable = ({
  paginationObj,
  sort,
  setSort,
  list,
  fetchProjects,
  manager,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  return (
    <>
      <div className="p-3">
        <div className="overflow-x-auto relative 
 border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  #
                </th>
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex">
                    <span>{startCase(t("O_PROJECT"))} </span>
                    <span>
                      {sort.sortKey === "name" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "name" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_PROJECT") + t("O_ARABIC")}
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "floorName" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "floorName",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "floorName",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_FLOOR_NAME")}</span>
                    <span>
                      {sort.sortKey === "floorName" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "floorName" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 cursor-pointer">
                  <div className="flex">
                    <span>{t("O_FLOOR_NAME") + t("O_ARABIC")}</span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortKey === "floorId" && sort.sortType === "asc") {
                      setSort({
                        sortKey: "floorId",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "floorId",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_FLOOR_ID")}</span>
                    <span>
                      {sort.sortKey === "floorId" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "floorId" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "createdAt" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_CREATED_AT")}</span>
                    <span>
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "createdAt" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_UPDATED_AT")}</span>
                    <span>
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>

                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list?.map((item, i) => (
                  <tr
                    key={i}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                  >
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className="py-2 px-2 border-r text-DarkBlue">
                      <a
                        href={`${process.env.REACT_APP_WEBSITE_BASE_URL}/project/${item.slug}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {item?.project?.title}
                      </a>
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.project?.titleAr}
                    </td>
                    <td className="py-2 px-2 border-r">{item?.floorId}</td>
                    <td className="py-2 px-2 border-r">{item?.floorName}</td>
                    <td className="py-2 px-2 border-r">{item?.floorNameAr}</td>
                    <td className="py-2 px-2 border-r">
                      {dayjs(item?.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {dayjs(item?.updatedAt).format("DD-MM-YYYY")}
                    </td>

                    <td className="py-4 px-6 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          {(manager?.add || user?.role === "admin") && (
                            <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <Link
                                title={t("O_EDIT_PROJECT_FLOOR")}
                                to={`/project-floors/edit-project-floor/${item._id}`}
                                state={{ item }}
                              >
                                <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(list) && (
                <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6" colSpan={12}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ProjectTable;
